import { render, staticRenderFns } from "./HeroAnnouncementEmployee.vue?vue&type=template&id=4a1489f1&scoped=true"
import script from "./HeroAnnouncementEmployee.vue?vue&type=script&lang=ts"
export * from "./HeroAnnouncementEmployee.vue?vue&type=script&lang=ts"
import style0 from "./HeroAnnouncementEmployee.vue?vue&type=style&index=0&id=4a1489f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1489f1",
  null
  
)

export default component.exports